import React from 'react';

import { MetaBarContainer, Socials, IconLink, Prev, Next, DesktopSplit } from './styled-components';
import { Facebook, Twitter, Pinterest, Mail, ArrowLeft, ArrowRight } from './icons';

const MetaBar = ({ post }) => {
  if(typeof window === 'undefined') {
    return null;
  }
  
  const prev = window.prevUrl;
  const next = window.nextUrl;

  return (
    <MetaBarContainer>

      <Socials>
        <IconLink key={'facebook'} href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}>
          <Facebook />
        </IconLink>

        <IconLink key={'twitter'} href={`http://twitter.com/share?url=${window.location.href}`}>
          <Twitter />
        </IconLink>

        <IconLink key={'pinterest'} href={`http://pinterest.com/pin/create/button/?url=${window.location.href}`}>
          <Pinterest />
        </IconLink>

        <IconLink key={'mailto'} href={`mailto:?subject=${post.title}&body=${window.location.href}`}>
          <Mail />
        </IconLink>
      </Socials>

      {prev && (
        <Prev href={prev}>
          <ArrowLeft />
          Vorheriger
        </Prev>
      )}

      {prev && next && <DesktopSplit>/</DesktopSplit>}

      {next && (
        <Next href={next}>
          Nächster
          <ArrowRight />
        </Next>
      )}
    </MetaBarContainer>
  );
};

MetaBar.defaultProps = {
  post: {
    title: 'Post Title'
  }
};

export default MetaBar;
